module.exports = __webpack_public_path__ + "img/brand_12.e7cff1c6.png";